<template>
  <div class="personalIntroduction">
    <div class="header">
        <img src="../assets/personalIntroduction/title.png" >
    </div>
    <div class="one">
      <div class="content">
        <img class="left listNum" src="../assets/personalIntroduction/one.png" >
        <div class="center">
            2008年出國創業，<br>經過十多年的打拼，<br>成為了迪拜區塊鏈領軍人物和迪拜創業傳奇，<br>成為世界虛擬貨幣論壇主講嘉賓。<br>
            一個有情懷有使命有10多年成功創業經驗的鋼鐵俠。這個鋼鐵俠，騰訊新聞、今日頭條、光明網、網易財經、搜狐財經、新浪財經、北京晨報等數十家媒體都有過他的報道。
        </div>
        <div class="right">
            <img src="../assets/personalIntroduction/one_right01.png" >
            <p><span>百度搜索廖望</span></p>
        </div>
      </div>
    </div>
    <div class="two">
      <div class="content">
        <img class="left listNum" src="../assets/personalIntroduction/two.png" >
        <div class="right">
            <div class="top">
              <p>廖望（CEO）作為“讓天下有更好用的加密貨幣”</p>
              <p>“用區塊鏈讓美元霸權剝削不了中國人”思想的提出者</p>
            </div>
            <div class="center">
              <p>作為用毛澤東思想幹區塊鏈的改革行動家</p>
              <p>作為佈雷頓森林體係願景實踐者</p>
              <p>作為想用區塊鏈改變世界的瘋子</p>
            </div>
            <div class="line"></div>
            <div class="bottom">
              <p>他也是十足的足球愛好者</p>
              <p>一個緻力於用科技改變未來的創業者</p>
            </div>
        </div>
      </div>
    </div>
    <div class="three">
      <div class="content">
        <img class="left listNum" src="../assets/personalIntroduction/three.png" >
        <div class="right">
            <div class="top">
              <img src="../assets/personalIntroduction/three01.png" >
              <img src="../assets/personalIntroduction/three02.png" >
              <img src="../assets/personalIntroduction/three03.png" >
            </div>
            <div class="bottom">十多年間，他曆經磨難、不斷探索，從睡樓梯走道崛起，先後於2009年成立迪拜原子能房産有限公司，投資過數百套房産。2012年廖望通過迪拜著名律師事務所BSA擔保交易收購尼日利亞政府國家資産管理局在迪拜的46套房産 ；2013年從尼日力亞國家資産管理局收購迪拜大洋騰挪資産管理有限公司；2017年1月，廖望10美金的時候大量買入以太坊，萊特幣； 2017年10到12月，廖望大量增持比特幣，萊特幣，瑞波幣；2018年4月成立開曼原子基金有限公司作為原子幣的發行主體，成立了原子鏈項目。</div>
        </div>
      </div>
    </div>
    <div class="four">
        <div class="content">
          <div class="top">
            <img class="img01" src="../assets/personalIntroduction/four.png" >
            <img class="img02" src="../assets/personalIntroduction/common.png" >
          </div>
          <div class="bottom1">
              <p>十年磨一劍，通過艱苦打拚，廖望成為了迪拜華人創業傳奇；實現個人財富自由以後，心係祖國人民，於2018年躊躇滿誌，回到祖國，開啓了人生中又一次創業傳奇：</p><br>
              <p>2018年8月回國後在中國投資成立一係列科技公司；</p><br>
              <p>2018年11月央視主持人李雨霏採訪廖望並錄製節目《小原子也可以點亮世界》，並獲得2018年度新經濟領域最具創新力CEO；</p><br>
              <p>2019年10月30日，廖望受邀出席英國前首相佈朗可持續發展大講壇；</p><br>
              <p>2020年1月，應邀出席意大利前總理馬泰奧·倫齊先生在北京舉辦的“戰略合作夥伴新春聯誼會”晚宴活動；</p><br>
              <p>2020中國經濟新銳人物獎獲得者；</p><br>
              <p>2020年10月26日，廖望與麥克存儲達成戰略合作，將斥資一億元人民幣戰略投資麥客存儲，進軍分佈式存儲（IPFS）領域；</p><br>
              <p>2020年為抗擊疫情捐助100萬元，發動近300萬用戶為新冠疫情捐款，用區塊鏈給抗疫貢獻賦能；</p><br>
              <p>2021年再次捐助100萬元，成立“廖望助學基金”；</p><br>
              <p>2021年8月，原子鏈公益為河南水災籌集善款30餘萬元，CEO廖望親自帶領團隊將50餘噸物資搬運到專車上發往河南災區；</p><br>
              <p>2021年8月，廖望通過原子鏈資本購入12.6萬枚Filecoin，近10萬枚波卡幣，3000枚以太坊及數仟萬的其它加密貨幣；</p><br>
              <p>2021年10月21日，廖望參加中國通信委員會區塊鏈專委會主辦的“1024區塊鏈活動日”，發錶重要言論“世界是你的，也是我的，最後都是玩區塊鏈的”；</p><br>
              <p>2022年10月，廖望被聘為薩爾瓦多駐華大使館特邀區塊鏈行業顧問；</p><br>
              <p>2023年6月6日，廖望被北京贛州企業商會授予社會責任獎；</p><br>
              <p>2023年9月9日，廖望獲聘黑龍江大學校友導師及創業導師；</p><br>
              <p>2023年9月27日，廖望攜手北京公益發展促進會，向河北涿州塔照中心小營小學捐贈一所圖書館；</p><br>
              <p>2023年10月2日，廖望受邀參加母校興國平川中學百年校慶，並成立謝遠譜-廖望獎學金。10月3日向50位優秀學子發放獎學金；</p><br>
              <p>2023年11月17日，廖望受央企大有融創邀請，在2024數字消費產業發展高峰論壇上發表題為《數字消費的發展趨勢和前景》專題演講；</p><br>
              <p>2024年5月12日，在首屆僑界公益貢獻表彰活動中，原子鏈CEO廖望獲授:《僑界公益人物》；</p><br>
              <p>2024年7月30日，原子鏈CEO，廖望助學金設立人廖望受邀參加了清華大學、北京大學、北京師範大學誌願者關愛農村留守兒童活動。</p><br>
          </div>
          <div class="bottom2">
              <img class="four_01" src="../assets/personalIntroduction/four_01.png">
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_02.png">
                <img src="../assets/personalIntroduction/four_03.png">
              </div>
          </div>
          <div class="line"></div>
          <div class="bottom3">
            <div class="top">
              <div>
                <p>
                  除此之外，廖望擔任了：<br>
                  北京贛州企業商會執行會長；<br>
                  阿聯酋江西商會執行會長；<br>
                  中國通信工業委員會區塊鏈專委會常委；<br>
                  迪拜原子能房產董事長；<br>
                  原子鏈創始人，樂唰創始人；<br>
                  薩爾瓦多駐華大使館特邀區塊鏈行業顧問；<br>
                  黑龍江大學校友導師及創業導師；<br>
                  廖望助學金設立人；<br>
                </p>
              </div>
              <img src="../assets/personalIntroduction/four_04.png" >
            </div>
            <!-- <p class="topP">中國管理科學研究院産業創新研究所客座教授。</p> -->
            <p class="topP">回國後短短三年，廖望又創造出了新的創業傳奇。這都要歸功於其魔法技能鐵人三項的魅力：</p>
            <div class="item">
              <p>(1) 創業已經有13年，13年整合團隊經驗和管理沈澱。剛開始創業頭幾年，由於管理上的錯誤，犯了成百上仟萬的血淚教訓，也因為一些不必要的執著痛失很多關鍵人才。冇有13年管理實戰經驗的學習，冇有13年中犯過的血淚錯誤，粘合和管理各種人才就不可能有今天的成熟。</p>
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_05.png">
                <img src="../assets/personalIntroduction/four_06.png">
              </div>
            </div>
            <div class="item">
              <p>(2) 愛鑽研，在感興趣的領域會做的很出色，能實現所謂的“不可能”。曾經的學霸，每個學科都考過第一，寫詩都寫全校第一。籃球場上一陣風，足球場上雞血哥。大學以1.6米多的身高，蹩腳的普通話，住貧睏生宿捨，嚇跑了係裏幾乎所有女同學。現在屌絲逆襲，贏得各國美女芳心，現任女友是波蘭國家運動員，實現金發碧眼大長腿的夢想。愛鑽研，能解決各種一般人解決不了的問題。舉個例子“家裏大別墅監控安裝的是最新款，有10年安裝經驗的巴基斯坦師傅搞不定，我用了半個晚上研究，自己搞定。”“車胎壞了，朋友卸載備胎，卸載半天冇成功，我研究3分鍾，搞定。”自己想要做成的領域，都能成為該領域的佼佼者。</p>
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_07.png">
                <img src="../assets/personalIntroduction/four_08.jpg">
              </div>
            </div>
            <div class="item">
              <p>(3) 國際視野：10多年海外經驗，遊曆各國。交往各國朋友，非常融入國外的文化。英文說的跟普通話一樣。極具國際視野。原子幣是解決國際間支付自由痛點的，必須要有國際視野。國內ICO不合法，禁止各種加密貨幣交易，決定了幹這個事情必須要在國外，必須要有國際視野。</p>
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_09.jpg">
                <img src="../assets/personalIntroduction/four_10.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="five">
        <div class="content">
          <div class="top">
            <img class="img01" src="../assets/personalIntroduction/five.png" >
            <img class="img02" src="../assets/personalIntroduction/common.png" >
          </div>
          <div class="bottom1">
            <div>
              <p>這幾項魔法技能中的單項可能很多人都有，但是三項都有，而且充滿鬥誌，世間難尋。</p><br>
              <p>“有誌者事竟成”！廖望先生新的創業傳奇，大幕已經開啓!</p><br>
              <p>未來的路還很長，他堅信：“事在人為，小原子也可以點亮世界”！正如廖望的名句“人就像一顆原子，很微小，但是潛力無限，通過鏈接釋放的能量可以點亮世界”。</p>
            </div>
            <img src="../assets/personalIntroduction/five_01.png" >
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import { enums } from "../../../enum";
export default {
  name: 'personalIntroduction',
  data() {
    return {
      
    };
  },
  mounted() {
   
  },
  methods: {
    
  },
};
</script>
<style scoped>
.personalIntroduction
{
  width: 100%;
  min-height: 100%;
  font-size: 0.2rem;
}
.header img{
  width: 100%;
  height: 5.96rem;
}
/* 1 2*/
.one,.two{
  width: 100%;
  padding: 0.16rem 0;
  height: auto;
  background: linear-gradient(-90deg, #DBE0F4, #EAEDFC, #D9DEF4);
}
.two{
  padding-top: 0;
}
.one .content,.two .content,.three .content
{
  display: flex;
  width: 100%;
  height: auto;
  padding: 0.16rem 0.14rem 0.3rem;
  background: #fff;
}
.listNum{
  margin-right: 0.16rem;
  width: 0.42rem;
  height: 2.2rem;
}
.one .content .center{
  line-height: 0.36rem;
  color: #333E50;
}
.one .content .right{
  text-align: center;
}
.one .content .right img{
  margin-left: 0.23rem;
  width: 3.78rem;
  height: 3.1rem;
}
.one .content .right p{
  display: inline-block;
  height: 0.28rem;
}
.one .content .right p span{
  padding: 0 0.34rem;
  line-height: 0.28rem; 
  text-align: center;
  background: #333E50;
  color: #FFF;
  letter-spacing: 0.1rem;
}
/* 2 */
.two .top p:nth-child(1){
  margin-bottom: 0.2rem;
  margin-top: 0.16rem;
  display: inline-block;
  width: 5.86rem;
  height: 0.44rem;
  font-size: 0.24rem;
  line-height: 0.44rem;
  text-align: center;
  background: #333E50;
  color: #FFF;
  letter-spacing: 0;
}
.two .top p:nth-child(2){
  display: inline-block;
  width: 5.86rem;
  height: 0.44rem;
  font-size: 0.24rem;
  line-height: 0.44rem;
  text-align: center;
  background: #333E50;
  color: #FFF;
  letter-spacing: 0;
}
.two .line
{
  margin: 0.2rem auto 0;
  width: 5.08rem;
  height: 0.02rem;
  border-bottom: 0.02rem dashed #8397B0;
}
.two .center,.two .bottom{
  margin-top: 0.12rem;
  text-align: center;
}
.two .center p,.two .bottom p{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
/* 3 */
.three .content .right 
{
  text-align: center;
}
.three .content .right .top
{
  display: flex;
  margin-bottom: 0.2rem;
}
.three .content .right .top img
{
  width:2.1rem;
  height: 2.1rem;
}
.three .content .right .top img:nth-child(2)
{
  margin: 0 0.12rem;
}
.three .content .bottom
{
  text-align: left;
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
/* 4 */
.four
{
  padding-top: 0.16rem;
  width: auto;
  height: auto;
  background: #FFF;
  background: linear-gradient(-90deg, #DBE0F4, #EAEDFC, #D9DEF4);
}
.four .content
{
  padding: 0 0.16rem 0.3rem 0.16rem;
  width: 100%;
  height: auto;
  background: #FFF;
}
.four .top
{
  position: relative;
}
.four .top .img01
{
  position: absolute;
  top: 0.16rem;
  left: 0;
  width: 2.06rem;
  height: 0.72rem;
}
.four .top .img02
{
  position: absolute;
  top: 0;
  right: 0.6rem;
  width: 2.28rem;
  height: 0.68rem;
}
.four .bottom1
{
  padding-top: 1.1rem;
}
.four .bottom1 p
{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
.four .bottom2
{
  margin-top: 0.28rem;
  display: flex;
  margin-bottom: 0.3rem;
}
.four .bottom2 .imgs
{
  display: flex;
  flex-direction: column;
}
.four .bottom2 .four_01
{
  margin-right: 0.1rem;
  width: 3.22rem;
  height: 4.36rem;
}
.four .bottom2 .imgs img
{
  margin-bottom: 0.1rem;
  width: 3.72rem;
  height: 2.12rem;
}
.four .bottom2 .imgs img:nth-child(2)
{
  margin-bottom: 0;
}
.four .line
{
  width: 100%;
  height: 0.02rem;
  border-bottom: 0.02rem solid #333E50;
}
.bottom3 .top
{
  display: flex;
}
.bottom3 .top div,.bottom3 .top img
{
  flex: 1;
}
.bottom3 .top img
{
  width: 3.8rem;
  height: 2.2rem;
}
.bottom3 .top p
{
  margin-top: 0.48rem;
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.46rem;
}
.bottom3 .topP,.bottom3 .item p
{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.46rem;
}
.bottom3 .item .imgs
{
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
  display: flex;
}
.bottom3 .item img
{
  width: 3.48rem;
  height: 2.48rem;
}
.bottom3 .item img:nth-child(1)
{
  margin-right: 0.1rem;
}
/* 5 */
.five
{
  padding-top: 0.16rem;
  width: auto;
  height: auto;
  background: #FFF;
  background: linear-gradient(-90deg, #DBE0F4, #EAEDFC, #D9DEF4);
}
.five .content
{
  padding: 0 0.16rem 0.3rem 0.16rem;
  width: 100%;
  height: auto;
  background: #FFF;
}
.five .top
{
  position: relative;
}
.five .top .img01
{
  position: absolute;
  top: 0.16rem;
  left: 0;
  width: 2.06rem;
  height: 0.72rem;
}
.five .top .img02
{
  position: absolute;
  top: 0;
  right: 0.6rem;
  width: 2.28rem;
  height: 0.68rem;
}
.five .bottom1
{
  padding-top: 1.16rem;
  display: flex;
}
.five .bottom1 p
{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
.five .bottom1 img
{
  width: 1.78rem;
  height: 3.06rem;
}
</style>





// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/personalIntroduction.vue